import { onReady } from './on-ready.js';
import { onActivateKey } from './keyboard.js';

function initSwiperPauseButtons() {
    document.querySelectorAll('.swiper-button-pause-button').forEach((button) => {
        const swiper = button.closest('.swiper-container')?.swiper;
        if (!swiper) {
            return;
        }

        const toggle = () => {
            const pauseIcon = button.querySelector('.pause-icon');
            const playIcon = button.querySelector('.play-icon');
            if (swiper.autoplay.running) {
                swiper.autoplay.stop();
                if (pauseIcon) pauseIcon.style.display = 'none';
                if (playIcon) playIcon.style.display = 'inline';
                button.setAttribute('aria-label', 'Play carousel');
            } else {
                swiper.autoplay.start();
                if (pauseIcon) pauseIcon.style.display = 'inline';
                if (playIcon) playIcon.style.display = 'none';
                button.setAttribute('aria-label', 'Pause carousel');
            }
        };

        button.addEventListener('click', toggle);
        onActivateKey(button, () => button.click());
    });
}

onReady(initSwiperPauseButtons);
